export const smtpCredentialsTestStatus = {
  todo: 'todo',
  inProgress: 'in_progress',
  warning: 'warning',
  failed: 'failed',
  done: 'done',
  skip: 'skip',
} as const;
